<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">Solicitações do site</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            { text: 'Início', disabled: false, to: '/home', exact: true },
                            { text: 'Solicitações do site', disabled: true, exact: true },
                        ]"></v-breadcrumbs>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtro</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="reload">
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-select dense outlined hide-details label="Tipo" v-model="filter.kind"
                                        :items="kindOptions" item-value="id" item-text="name" @change="reload"></v-select>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-select dense outlined hide-details label="Status" v-model="filter.status"
                                        :items="statusOptions" item-value="id" item-text="name" @change="reload"></v-select>
                                </v-col>
                                <v-col cols="12" md="5">
                                    <v-text-field dense outlined hide-details label="Protocolo, nome ou e-mail"
                                        v-model="filter.search" append-icon="mdi-magnify"
                                        @click:append="reload"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Solicitações</v-card-title>
                    <v-card-text>
                        <v-data-table :headers="headers" :items="items" :server-items-length="count"
                            :options.sync="options" :loading="loading" :disable-sort="true"
                            :footer-props="{ itemsPerPageText: 'Itens por página:', itemsPerPageOptions: [10, 20, 50], pageText: '{0}-{1} de {2}' }"
                            no-data-text="Nenhuma solicitação encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table" @click:row="openItem">
                            <template v-slot:[`item.kind`]="{ item }">{{ kindName(item.kind) }}</template>
                            <template v-slot:[`item.name`]="{ item }">
                                {{ item.anonymous ? 'Anônimo' : (item.name || '—') }}
                            </template>
                            <template v-slot:[`item.client`]="{ item }">{{ item.client ? item.client.name : '—' }}</template>
                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small label :color="statusColor(item.status)" text-color="white">
                                    {{ statusName(item.status) }}</v-chip>
                            </template>
                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm") }}
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="detail.show" max-width="760">
            <v-card v-if="detail.data">
                <v-card-title>
                    {{ kindName(detail.data.kind) }} · {{ detail.data.protocol }}
                    <v-spacer></v-spacer>
                    <v-btn icon @click="detail.show = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-subtitle>Recebida em {{ detail.data.created_at | defaultDate("DD/MM/YYYY HH:mm") }}</v-card-subtitle>
                <v-card-text>
                    <table class="request-fields">
                        <tr v-for="field in detailFields" :key="field.label">
                            <th>{{ field.label }}</th>
                            <td>{{ field.value }}</td>
                        </tr>
                    </table>

                    <div v-if="detail.data.files.length" class="mt-4">
                        <p class="font-weight-bold mb-1">Arquivos</p>
                        <div v-for="file in detail.data.files" :key="file.id">
                            <v-icon small class="mr-1">mdi-paperclip</v-icon>
                            <a :href="file.file_url" target="_blank" rel="noopener">{{ file.label }}: {{ file.file_name }}</a>
                        </div>
                    </div>

                    <v-row class="mt-4">
                        <v-col cols="12" md="5">
                            <v-select dense outlined hide-details label="Status" v-model="detail.status"
                                :items="statusOptions.slice(1)" item-value="id" item-text="name"></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-textarea dense outlined hide-details="auto" label="Notas internas" rows="3" auto-grow
                                counter="5000" v-model="detail.notes"></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="detail.show = false">Fechar</v-btn>
                    <v-btn color="primary" elevation="0" :loading="detail.saving" @click="saveDetail">Salvar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import axios from "axios";

const KINDS = [
    { id: "", name: "Todas" },
    { id: "ppp", name: "PPP" },
    { id: "career", name: "Trabalhe conosco" },
    { id: "report", name: "Denúncia" },
];

const STATUSES = [
    { id: "", name: "Todos" },
    { id: 0, name: "Recebida", color: "warning" },
    { id: 1, name: "Em andamento", color: "info" },
    { id: 2, name: "Concluída", color: "success" },
    { id: 3, name: "Arquivada", color: "grey" },
];

export default {
    name: "SiteRequestList",

    data: () => ({
        loading: false,
        items: [],
        count: 0,
        options: { page: 1, itemsPerPage: 10 },
        filter: { kind: "", status: "", search: "" },
        kindOptions: KINDS,
        statusOptions: STATUSES,
        headers: [
            { text: "Protocolo", value: "protocol" },
            { text: "Tipo", value: "kind" },
            { text: "Nome", value: "name" },
            { text: "Empresa", value: "client" },
            { text: "Status", value: "status" },
            { text: "Recebida em", value: "created_at" },
        ],
        detail: { show: false, saving: false, data: null, status: 0, notes: "" },
    }),

    computed: {
        detailFields() {
            const data = this.detail.data || {};
            return [
                { label: "Identificação", value: data.anonymous ? "Anônima" : null },
                { label: "Nome", value: data.name },
                { label: "CPF", value: data.registration },
                { label: "E-mail", value: data.email },
                { label: "Telefone", value: data.phone_number },
                { label: "Endereço", value: data.address },
                { label: "Empresa", value: data.client ? data.client.name : null },
                { label: "Área de interesse", value: data.subject },
                { label: "Mensagem", value: data.message },
            ].filter((field) => field.value);
        },
    },

    watch: {
        options: {
            handler() {
                this.load();
            },
            deep: true,
        },
    },

    methods: {
        kindName(kind) {
            return (KINDS.find((item) => item.id === kind) || {}).name || kind;
        },
        statusName(status) {
            return (STATUSES.find((item) => item.id === status) || {}).name || "—";
        },
        statusColor(status) {
            return (STATUSES.find((item) => item.id === status) || {}).color || "grey";
        },

        reload() {
            if (this.options.page !== 1) this.options.page = 1;
            else this.load();
        },

        async load() {
            this.loading = true;
            try {
                const result = await axios.get("/api/admin/site-requests", {
                    params: { ...this.filter, page: this.options.page, limit: this.options.itemsPerPage },
                });
                this.items = result.data.content.data;
                this.count = result.data.content.paging.total;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.loading = false;
            }
        },

        async openItem(item) {
            try {
                const result = await axios.get(`/api/admin/site-requests/${item.id}`);
                this.detail.data = result.data.content;
                this.detail.status = this.detail.data.status;
                this.detail.notes = this.detail.data.notes || "";
                this.detail.show = true;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            }
        },

        async saveDetail() {
            this.detail.saving = true;
            try {
                await axios.patch(`/api/admin/site-requests/${this.detail.data.id}`, {
                    status: this.detail.status,
                    notes: this.detail.notes,
                });
                this.$dialog.notify.info("Solicitação atualizada", { position: "top-right", timeout: 2000 });
                this.detail.show = false;
                this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 5000 });
            } finally {
                this.detail.saving = false;
            }
        },
    },
};
</script>

<style scoped>
.request-fields {
    width: 100%;
    border-collapse: collapse;
}
.request-fields th {
    width: 160px;
    padding: 8px 12px 8px 0;
    color: #6b7480;
    font-weight: 500;
    text-align: left;
    vertical-align: top;
}
.request-fields td {
    padding: 8px 0;
    white-space: pre-line;
}
.request-fields tr + tr {
    border-top: 1px solid #eee;
}
</style>
